import * as R from 'ramda';

const loginAPI = (state) => R.pathOr('', ['LoginReducer', 'loginAPI'], state);
const loginSuccess = (state) => R.pathOr('', ['LoginReducer', 'loginSuccess'], state);

const selector = {
    loginAPI,
    loginSuccess
}
export default selector